












import { Component, Prop, Vue } from 'vue-property-decorator';

import SelectionBox from '@/componentsV2/molecules/Inputs/SelectionBox.vue';

@Component({
  components: {
    SelectionBox
  }
})
export default class DeactivationReasons extends Vue {
  @Prop() changeReasons!: Function;
  @Prop() form!: any;

  options = [
    "I don't need it anymore",
    "It's missing features I need",
    'I just wanted to try it out',
    "I'm having a technical issue",
    'I found an alternative solution',
    'I added it by mistake',
    "It's too expensive for me",
    'I’m not ready to promote my program',
    'Other'
  ];
}
